// extracted by mini-css-extract-plugin
module.exports = {"toaster":"Toaster_toaster__bSB7H","icon":"Toaster_icon__WtL05"};